/// <amd-module name="Wiki/Editor/Components/CloseEditorDialog" />
import * as React from "react";

import { Dialog } from "VSSUI/Dialog";

import * as Resources from "Wiki/Editor/Resources";

interface ICloseEditorDialogProps {
    onDismiss: () => void;
    closeEditor: () => void;
}

const continueEditingClassName = "continue-editing";

export class CloseEditorDialog extends React.PureComponent<ICloseEditorDialogProps> {
    public render(): JSX.Element {
        const { onDismiss, closeEditor } = this.props;

        return (
            <Dialog
                onDismiss={onDismiss}
                titleProps={{ text: Resources.UnsavedChanges_DialogTitle }}
                footerButtonProps={[
                    {
                        text: Resources.Discard_Label,
                        onClick: () => {
                            onDismiss();
                            closeEditor();
                        },
                        className: "close-editor-btn"
                    },
                    {
                        text: Resources.ContinueEditing_Label,
                        primary: true,
                        onClick: onDismiss,
                        className: continueEditingClassName
                    }
                ]}
                defaultActiveElement={"." + continueEditingClassName}
            >
                <div className="we-close-dialog-content">{Resources.UnsavedChanges_DialogMessage}</div>
            </Dialog>
        );
    }
}
